"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedVersionState = void 0;
/** Possible Named Version states. */
var NamedVersionState;
(function (NamedVersionState) {
    /** Visible. Named Version should be present in displayed Named Version lists. */
    NamedVersionState["Visible"] = "visible";
    /** Hidden. Named Version is intended to be hidden in displayed Named Version lists. */
    NamedVersionState["Hidden"] = "hidden";
})(NamedVersionState = exports.NamedVersionState || (exports.NamedVersionState = {}));
//# sourceMappingURL=NamedVersionInterfaces.js.map